import { Component } from "@angular/core";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesMisc } from "src/app/core/entities/configuracoesMisc";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";

@Component({
  selector: "gcc-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
})
export class FooterComponent {
  SITE: ConfiguracoesSite;
  MISC: ConfiguracoesMisc = {
    fotterProps: {

    }
  }

  public midiasSociais;
  public institucionalTitle1: string = "";
  public institucionalTitle2;
  public ondeEstamos;
  public API_IMAGENS: String;
  public API_IMAGENS_PRODUTOS: String;
  public mostraCopyright = ""
  public footer = [
    // {
    //   "midias": [
    //     {
    //       "descricao": null,
    //       "codigoHTML": "<i>html</i>",
    //       "id": null
    //     }
    //   ]
    // },
    // {
    //   "Politicas Comerciais": [
    //     {
    //       "descricao": "Quem Somos",
    //       "codigoHTML": null,
    //       "detalhe": "<h1>html</h1>"
    //     },
    //     {
    //       "descricao": "onde Estamos",
    //       "codigoHTML": null,
    //       "detalhe": "<h1>html</h1>"
    //     }
    //   ]
    // }
  ]

  
  public values = [];
  /*public values:Array<InfoPageValue> = [
    {pageId: 'quem-somos', label: 'Quem Somos', group:1, html: '<h2>Quem Somos</h2>'},
    {pageId: 'como-comprar', label: 'Como Comprar', group:2, html: '<h2>Como Comprar</h2>'},
  ];*/

  // constructor() {
  //   this.SITE = Configuracoes.SITE;
  //   this.MISC = Configuracoes.MISC;
  //   this.API_IMAGENS = Configuracoes.API_IMAGENS;
  //   this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
  //   this.institucionalTitle1 = Configuracoes.SITE.institucionalTitle1;
  //   this.institucionalTitle2 = Configuracoes.SITE.institucionalTitle2;
  //   this.values = Configuracoes.SITE.infoPage;
  //   this.ondeEstamos = Configuracoes.SITE.ondeEstamos;
  //   this.midiasSociais = Configuracoes.SITE.midiasSociais;
  // }

  ngOnInit() {
    if (Configuracoes.SITE !== undefined && Configuracoes.SITE.institucionalTitle1) {
      this.institucionalTitle1 = Configuracoes.SITE.institucionalTitle1;
    }
    if (Configuracoes.SITE !== undefined && Configuracoes.SITE.institucionalTitle2) {
      this.institucionalTitle2 = Configuracoes.SITE.institucionalTitle2;
    }
    if (Configuracoes.SITE !== undefined && Configuracoes.SITE.mostraCopyright) {
      this.mostraCopyright = Configuracoes.SITE.mostraCopyright;
    }
    if (Configuracoes.API_IMAGENS) {
      this.API_IMAGENS = Configuracoes.API_IMAGENS;
    }
    if (Configuracoes.API_IMAGENS_PRODUTOS) {
      this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    }
    if (Configuracoes.SITE !== undefined && Configuracoes.SITE.infoPage) {
      this.values = Configuracoes.SITE.infoPage;
    }
    if (Configuracoes.SITE !== undefined && Configuracoes.SITE.ondeEstamos) {
      this.ondeEstamos = Configuracoes.SITE.ondeEstamos;
    }
    if (Configuracoes.SITE !== undefined && Configuracoes.SITE.midiasSociais) {
      this.midiasSociais = Configuracoes.SITE.midiasSociais;
    }
    if (Configuracoes.SITE) {
      this.SITE = Configuracoes.SITE;
    }
    if (Configuracoes.MISC) {
      this.MISC = Configuracoes.MISC;
    }

  }
  
  getKey(obj: any): string {
    return Object.keys(obj)[0];
  }
  
}
